import { RiderHelper } from './RiderHelper';

export function buildQuickScheduleDraft({
  step1,
  step2,
  step3,
  step4,
  user,
  existingDraft,
  driverLegANotes = '',
  driverLegBNotes = '',
  driverNotes = '',
  isUberRoundTrip = false,
}) {
  const defaultOrgId =
    user?.organizationId ||
    user?.organization?.id ||
    user?.permissions?.orgList?.[0]?.id ||
    null;

  const normalizedStep1 = {
    ...(step1 || {}),
    organizationId: step1?.organizationId || defaultOrgId,
    riderInfo: {
      ...(step1?.riderInfo || {}),
    },
  };

  const riderInfo = normalizedStep1.riderInfo || {};
  if (!normalizedStep1.formattedRiderName && (riderInfo.firstName || riderInfo.lastName)) {
    normalizedStep1.formattedRiderName = RiderHelper.getRiderAutoCompleteName(riderInfo);
  }

  const rideNotesValue = isUberRoundTrip
    ? `${driverLegANotes}\n\n${driverLegBNotes}`
    : driverNotes || driverLegANotes;

  const normalizedStep4 = {
    ...(step4 || {}),
    rideNotes: rideNotesValue || step4?.rideNotes || '',
  };

  return {
    ...(existingDraft || {}),
    step1: normalizedStep1,
    step2: step2 || {},
    step3: step3 || {},
    step4: normalizedStep4,
  };
}

export function hasQuickScheduleDraftData(draft) {
  const step1 = draft?.step1 || {};
  const riderInfo =
    (typeof step1.riderInfo === 'object' && step1.riderInfo) ||
    step1.riderDraft ||
    {};

  return Boolean(
    step1.formattedRiderName ||
      step1.riderInfo?.id ||
      step1.riderDraft?.id ||
      riderInfo.firstName ||
      riderInfo.lastName ||
      riderInfo.phoneNumber ||
      draft?.step2?.vehicleType ||
      draft?.step3?.pickupAddressDetails?.formattedAddress ||
      draft?.step3?.destinationAddress?.formattedAddress ||
      draft?.step3?.pickUpDate?.datetime ||
      draft?.step4?.costCenter ||
      draft?.step4?.rideNotes,
  );
}
